import _ from 'lodash';
import './medicalInfoTOS.scss';
import template from './medicalInfoTOS.html';

class MedicalInfoTOSModalController {
    /* @ngInject */
    constructor($q, dataContext) {
        this.data = this.config.data;
        this.dataContext = dataContext;
        this.$q = $q;
        this.$close = this.config.close;
        this.$dismiss = this.config.dismiss;
        
    }

    submit() {
        this.$close(true);
    }

    close() {
        this.$close(false);
    }
}

export default {
    template: template,
    bindings: {
        config: '<'
    },
    controller: MedicalInfoTOSModalController
};